import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function ProductcategoryInfo(){
  const { productcategoryObj} = useSelector((state)=>state.dmpslice.productcategoryDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Agency"  value={ productcategoryObj.agency!==null && productcategoryObj.agency!==undefined?productcategoryObj.agency:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ productcategoryObj.businessid!==null && productcategoryObj.businessid!==undefined?productcategoryObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="title"  value={ productcategoryObj.title!==null && productcategoryObj.title!==undefined?productcategoryObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Id"  value={ productcategoryObj.productid!==null && productcategoryObj.productid!==undefined?productcategoryObj.productid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Category Id"  value={ productcategoryObj.categoryid!==null && productcategoryObj.categoryid!==undefined?productcategoryObj.categoryid:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}